import React from "react";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import { Card, Row, Space, ProgressBar } from "@masterteam/mt-design-react";
import useIsAr from "../../../Hooks/useIsAr";

import "./style.scss";

const InitiativeCard = ({ data }) => {
  const [isAr] = useIsAr();
  const intl = useIntl();
  const history = useHistory();

  return (
    <Card
      className="card-wrapper cursor"
      onClick={() => {
        history.push(`/splus/initiative-details/${data.ID}`);
      }}
    >
      <Row className="title">
        <div className="value">{isAr ? data.ArabicName : data.EnglishName}</div>
      </Row>

      <Row className="manager" justify="between">
        <Space direction="vertical" size="small">
          <div className="value">{data?.ManagerModel?.DisplayName}</div>
          <div className="label">
            {intl.formatMessage({
              id: "initiative.initiative-owner",
            })}
          </div>
        </Space>

        <Space direction="vertical" size="small">
          <div className="value">{data?.Code}</div>
          <div className="label">
            {intl.formatMessage({
              id: "initiative.code",
            })}
          </div>
        </Space>
      </Row>

      <Row className="progress" gap="5px">
        <ProgressBar value={data?.Progress} color={data.ColorCode} />
        <span style={{ color: data.ColorCode }}>{data.Progress} %</span>
      </Row>

      <Row className="details" justify="between">
        <Space direction="vertical" className="item">
          <div className="value">{data?.ProgramsCount}</div>
          <div>
            {intl.formatMessage({
              id: "common.programs",
            })}
          </div>
        </Space>

        <Space direction="vertical" className="item">
          <div className="value">{data?.RisksCount}</div>
          <div>
            {intl.formatMessage({
              id: "common.risks",
            })}
          </div>
        </Space>
      </Row>
    </Card>
  );
};

export default InitiativeCard;
